/** @format */

// Room and use-case landing pages at /shades/<slug>. Kept apart from the page
// component so /shop can link to them without pulling that chunk in.
// Every slug here must also be in sitemap-generator.py.
export const ROOM_PAGES = [
	{ slug: "living-room-window-shades", label: "Living Room" },
	{ slug: "bedroom-window-shades", label: "Bedroom" },
	{ slug: "kitchen-window-shades", label: "Kitchen" },
	{ slug: "dining-room-window-shades", label: "Dining Room" },
	{ slug: "home-theatre-window-shades", label: "Home Theatre" },
	{ slug: "residential-window-shades", label: "Whole Home" },
	{ slug: "commercial-window-shades", label: "Commercial" },
];
